// AuthProvider.jsx (simplified)
import { createContext, useContext, useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      setUser(firebaseUser);
      if (firebaseUser) {
        const snap = await getDoc(doc(db, "users", firebaseUser.uid));
        setUserData(snap.exists() ? snap.data() : null);
      } else {
        setUserData(null);
      }
      setAuthLoading(false);
    });
    return () => unsub();
  }, []);

  // Optional: helper to refresh user data
  const refreshUserData = async () => {
    if (user) {
      const snap = await getDoc(doc(db, "users", user.uid));
      setUserData(snap.exists() ? snap.data() : null);
    }
  };

  return (
    <AuthContext.Provider
      value={{ user, userData, authLoading, refreshUserData }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
